"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FMIGroupe = void 0;
exports.FMIGroupe = {
    id: 'fmiGroupe',
    companyName: 'FMI Groupe',
    transportModes: ['sea', 'air'],
    freightGate: {
        isOnboarded: true,
        realm: 'fmiGroupe',
    },
    isInternal: false,
    isActive: true,
    countries: ['FR'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRk1JR3JvdXBlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2FnZW50cy9kYXRhL0ZNSUdyb3VwZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLFNBQVMsR0FBVTtJQUM1QixFQUFFLEVBQUUsV0FBVztJQUNmLFdBQVcsRUFBRSxZQUFZO0lBQ3pCLGNBQWMsRUFBRSxDQUFDLEtBQUssRUFBRSxLQUFLLENBQUM7SUFDOUIsV0FBVyxFQUFFO1FBQ1QsV0FBVyxFQUFFLElBQUk7UUFDakIsS0FBSyxFQUFFLFdBQVc7S0FDckI7SUFDRCxVQUFVLEVBQUUsS0FBSztJQUNqQixRQUFRLEVBQUUsSUFBSTtJQUNkLFNBQVMsRUFBRSxDQUFDLElBQUksQ0FBQztDQUNwQixDQUFBIn0=